"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorTypeList = void 0;
var colorTypeList = exports.colorTypeList = ['red', 'orange', 'yellow', 'green', 'cyan', 'blue', 'pink', 'purple', 'gray'];